import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { FC, Fragment } from "react";

import { Divider } from "@/components/General/Divider/divider.component";
import { Row } from "@/components/General/Grid/row.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";

import OrderItemComponent, {
    DeliveryPromiseComponentProps
} from "../OrderItem/orderItem.component";
import "./productCollectionBlock.scss";

type ProductCollectionBlockComponentProps = {
    icon: string;
    title: string;
    products: OrderItemModel[];
    deliveryType: DeliveryType;
    additionalServiceTooltip?: TooltipType;
    productTitleLink: boolean;
    DeliveryPromiseComponent: FC<DeliveryPromiseComponentProps>;
};

const ProductCollectionBlockComponent = ({
    icon,
    title,
    products,
    deliveryType,
    additionalServiceTooltip,
    productTitleLink,
    DeliveryPromiseComponent
}: ProductCollectionBlockComponentProps) => (
    <>
        <Row className="productCollectionBlock__title-bar">
            <i className={`las ${icon}`} />
            <h5 className="p-0 m-0">{title}</h5>
        </Row>
        {products.map((product, index) => (
            <Fragment key={`${title}-${index}`}>
                {index > 0 && <Divider marginTop="0" />}
                <OrderItemComponent
                    item={product}
                    deliveryType={deliveryType}
                    additionalServiceTooltip={additionalServiceTooltip}
                    productTitleLink={productTitleLink}
                    DeliveryPromiseComponent={DeliveryPromiseComponent}
                />
            </Fragment>
        ))}
    </>
);

export { ProductCollectionBlockComponent };
